export default function getInitState() {
    return {
        fixedGridIsOpen: true,
        alaCarteGridIsOpen: false,
        additionalTableConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-exchange-alt"></i> Váltás AlaCarte csomagokra',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'openAlaCarteGrid'
            },
        ],
        alacarteActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-exchange-alt"></i> Váltás fix csomagokra',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'closeAlaCarteGrid'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }],
        rowActions: [
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "hasCarePackageUnassignPermission"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "patientName",
                label: "Név",
                formType: 'text',
                formSize: 3,
                formVisible: true,
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "TAJ szám",
                formType: 'text',
                formSize: 3,
                formVisible: true,
            },
            {
                name: "packageName",
                label: "Csomag neve",
                formType: 'text',
                formSize: 3,
                formVisible: true,
            },
            {
                name: "expired",
                label: "Csomag elérhetősége",
                formType: 'select',
                selectOptions: {
                    externalOptionList: [
                        {id: '0', text: 'Elérhető'},
                        {id: '1', text: 'Lejárt'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    },
                },
                formSize: 3,
                formVisible: true,
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "id",
                visibility: false,
            },
            {
                name: "patientName",
                label: "Név",
                visibility: true,
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "TAJ szám",
                visibility: true,
            },
            {
                name: "packageName",
                label: "Csomag neve",
                visibility: true,
            },
            {
                name: "usedSlashMax",
                label: "Kezelések száma",
                visibility: true,
            },
            {
                name: "expired",
                label: "Csomag elérhetősége",
                visibility: true,
                slot_name: "formatExpiredPackage",
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        alaCarteHeaderFields: [
            {
                name: "id",
                label: "id",
                visibility: false,
            },
            {
                name: "patientName",
                label: "Név",
                visibility: true,
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "TAJ szám",
                sort: true,
                visibility: true,
            },
            {
                name: "packageName",
                label: "Csomag neve",
                visibility: true,
            },
            {
                name: "usedSlashMaxFix",
                label: "Fix kezelések száma",
                visibility: true,
            },
            {
                name: "usedSlashMaxVariable",
                label: "Választható kezelések száma",
                visibility: true,
            },
            {
                name: "expired",
                label: "Csomag elérhetősége",
                visibility: true,
                slot_name: "formatExpiredPackage",
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
